const _version = "2.7.5"
function version() {
    return _version;
}
export default version
